'use strict';

import 'babel-polyfill';
import 'components/footer';
import 'components/mobileNavigation';
import 'components/passwordToggle';
import 'components/primaryNavigation';
import 'components/productCategory';
import 'components/relatedProducts';
import 'components/searchBar';
import 'components/submittal';
import 'components/magnificPopup';
import 'components/priceSheets';
import 'components/contactUs';
//import 'components/resultsLayout';
import 'components/googleTranslate';
import 'components/general';
import 'components/toggleSidebar';
import 'components/wardflexCalculator';
import 'components/slider';
//import 'components/spinner';
import 'components/dropdown';
//import 'components/profileInterests';
//import 'components/lightbox';
import 'remodal/dist/remodal';
import 'vue/app.js';

/* Configure all Axios requests to use a CSRF token that has been set in a meta tag on page load */
window.axios = require('axios');
window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

let token = document.head.querySelector('meta[name="csrf-token"]');
if (token) {
    window.axios.defaults.headers.common['X-CSRF-TOKEN'] = token.content;
} else {
    console.error('CSRF token not found');
}

// Open all PDF links in a new tab
document.addEventListener('DOMContentLoaded', function() {
    // Find all links that point to PDF files
    const pdfLinks = document.querySelectorAll('a[href$=".pdf" i], a[href*=".pdf?" i]');

    pdfLinks.forEach(function(link) {
        // Open in new tab
        link.target = '_blank';

        // Add security attribute
        link.rel = 'noopener noreferrer';
    });
});

// Also handle dynamically added PDF links
document.addEventListener('click', function(e) {
    if (e.target.tagName === 'A' && e.target.href) {
        const url = e.target.href.toLowerCase();
        if (url.includes('.pdf')) {
            e.target.target = '_blank';
            e.target.rel = 'noopener noreferrer';
        }
    }
});

// Handles converting CKEditor oembeds to iframes without external service
document.addEventListener('DOMContentLoaded', (event) => {
    // Find all oembed elements
    const oembedElements = document.querySelectorAll('oembed[url]');

    oembedElements.forEach(element => {
        const url = element.getAttribute('url');
        let videoId = null;
        if (!url) return;
        videoId = extractYouTubeId(url);

        if (videoId) {
            // Create the iframe element for YouTube
            const iframe = document.createElement('iframe');
            iframe.setAttribute('src', `https://www.youtube.com/embed/${videoId}`);
            iframe.setAttribute('width', '560'); // Set width
            iframe.setAttribute('height', '315'); // Set height
            iframe.setAttribute('frameborder', '0');
            iframe.setAttribute('allow', 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share');
            iframe.setAttribute('allowfullscreen', 'true');
            iframe.setAttribute('referrerpolicy', 'strict-origin-when-cross-origin');
            iframe.setAttribute('role', 'application');
            iframe.setAttribute('aria-label', "YouTube video player");
            iframe.setAttribute('title', "YouTube video player");
            iframe.loading = "lazy";
            iframe.style.aspectRatio = "16/9";
            iframe.style.width = "100%";
            iframe.style.display = "block";
            iframe.style.height = "auto";
            iframe.style.margin = "1.5rem auto";

            // Replace the oembed element with the iframe
            if(element.parentNode){
                element.parentNode.replaceChild(iframe, element);
            }
        }
    });

    // Function to extract the YouTube video ID from various URL formats
    function extractYouTubeId(url) {
        const regex = /(?:https?:\/\/)?(?:www\.)?(?:youtube\.com\/(?:[^\/\n\s]+\/\S+\/|(?:v|e(?:mbed)?)\/|\S*?[?&]v=)|youtu\.be\/)([a-zA-Z0-9_-]{11})/;
        const matches = url.match(regex);
        return matches ? matches[1] : null;
    }
});